<template>
  <div
    class="Herosearch"
    @click="toggleMarker"
  >
    <v-text-field 
      filled
      append-icon="mdi-map-marker"
      placeholder="Enter your adress "
      hint="Example: 23 avenue de John Doe"
      persistent-hint
      label="Search"
      :autofocus="autofocus"
      @click:append="toggleMarker"
      @click="toggleMarker"
    />
  </div>
</template>

<script>
export default {
  props: {
    autofocus : Boolean,
  },
  name: 'Herosearch',
  methods:{
    toggleMarker () {
        this.$router.push("searchresults")
      },
  }
}
</script>

<style scoped>
/* .Herosearch {

} */
</style>
